export default __webpack_public_path__ + "static/media/userProfile.d96b6ee5.svg";